/**
 * Initials for an avatar circle: "Graham Whitlock" → "GW" (APP-190). A display name's extras are
 * left out: anything in brackets ("Rosa Patel (eval)", "Robert (Bob) Smith") and anything after a
 * spaced dash ("Sam Ortega - MyRewards Test"). Each word starts at its first letter, so quotes and
 * punctuation never show. The first and last words give the two letters; with no word left, the
 * first letter in the whole name; with none at all, nothing.
 */
export function initialsOf(name: string): string {
  const core = name.replace(/\([^)]*\)|\[[^\]]*\]|\{[^}]*\}/g, ' ').split(/\s[-–—|]\s/)[0] ?? '';
  const letters = core
    .split(/\s+/)
    .map((word) => /\p{L}/u.exec(word)?.[0])
    .filter((letter): letter is string => letter !== undefined);
  const first = letters[0];
  if (first === undefined) return (/\p{L}/u.exec(name)?.[0] ?? '').toUpperCase();
  const last = letters.length > 1 ? (letters.at(-1) ?? '') : '';
  return `${first}${last}`.toUpperCase();
}
